import { ReactNode } from 'react';
import styles from './OpenFundSection.module.scss';

interface OpenFundSectionProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

const OpenFundSection = ({ title, children, className }: OpenFundSectionProps) => {
  return (
    <section className={`${styles.section} ${className || ''}`}>
      {title && <h3 className={`heading-h4-semibold ${styles.sectionTitle}`}>{title}</h3>}
      <div className={styles.content}>{children}</div>
    </section>
  );
};

export default OpenFundSection;
